/**
 * SSOT: האם החבילה כוללת העברות (שדה LDS isTransferIncluded).
 * מקבל string "true" / boolean true (וגם ערכים מקובלים נוספים).
 * @param {object|null|undefined} dealOrSelectedResult
 * @returns {boolean}
 */
export function isDealTransferIncluded(dealOrSelectedResult) {
  if (!dealOrSelectedResult || typeof dealOrSelectedResult !== "object") {
    return false;
  }
  const raw =
    dealOrSelectedResult.isTransferIncluded ??
    dealOrSelectedResult.transferIncluded ??
    dealOrSelectedResult.fullDeal?.isTransferIncluded ??
    dealOrSelectedResult.fullDeal?.transferIncluded;

  if (raw === true || raw === 1) return true;
  if (raw === false || raw === 0 || raw == null) return false;
  const s = String(raw).trim().toLowerCase();
  return s === "true" || s === "1" || s === "yes";
}
